// - A -
import AHorseWithNoName from './AHorseWithNoName';
import AmericanPie from './AmericanPie';
// - B -
import BabyBaluga from './BabyBaluga';
import BabyILoveYourWay from './BabyILoveYourWay';
import BackHome from './BackHome';
import BlowinInTheWind from './BlowinInTheWind';
import ButterflyKisses from './ButterflyKisses';
// - C -
import CantHelpFallingInLove from './CantHelpFallingInLove';
import ClosingTime from './ClosingTime';
import CountryRoads from './CountryRoads';
// - D -
import DontStopBelievin from './DontStopBelievin';
// - F -
import ForeverAndEverAmen from './ForeverAndEverAmen';
import FreeFallin from './FreeFallin';
// - G -
import GivingTree from './GivingTree';
import GodBlessTheUSA from './GodBlessTheUSA';
import GoodAsYou from './GoodAsYou';
// - H -
import HesGotTheWholeWorldInHisHands from './HesGotTheWholeWorldInHisHands';
import HomeOnTheRange from './HomeOnTheRange';
import HouseAtPoohCorner from './HouseAtPoohCorner';
// - I -
import ICantMakeYouLoveMe from './ICantMakeYouLoveMe';
import IKnowAnOldLadyWhoSwallowedAFly from './IKnowAnOldLadyWhoSwallowedAFly';
import ItsYourLove from './ItsYourLove';
// - J -
import Jumper from './Jumper';
// - K -
import KillingMeSoftly from './KillingMeSoftly';
import Kookaburra from './Kookaburra';
import Kumbaya from './Kumbaya';
// - L -
import LeanOnMe from './LeanOnMe';
import LeavingOnAJetPlane from './LeavingOnAJetPlane';
// - M -
import MaggieMay from './MaggieMay';
import MakeYouFeelMyLove from './MakeYouFeelMyLove';
import MichaelFinnegan from './MichaelFinnegan';
import MichaelRowTheBoatAshore from './MichaelRowTheBoatAshore';
import Mockingbird from './Mockingbird';
import MyBonnieLiesOverTheOcean from './MyBonnieLiesOverTheOcean';
// - N -
import NightChanges from './NightChanges';
// - O -
import OhSusanna from './OhSusanna';
import OnTopOfSpaghetti from './OnTopOfSpaghetti';
import OneTinSoldier from './OneTinSoldier';
import OverTheRainbow from './OverTheRainbow';
// - P -
import PuffTheMagicDragon from './PuffTheMagicDragon';
// - R -
import RainbowConnection from './RainbowConnection';
import RightHereWaiting from './RightHereWaiting';
// - S -
import SesameStreetIDontWantToLiveOnTheMoon from './SesameStreetIDontWantToLiveOnTheMoon';
import ShellBeComingRoundTheMountain from './ShellBeComingRoundTheMountain';
import SittinOnTheDockOfTheBay from './SittinOnTheDockOfTheBay';
import StandByMe from './StandByMe';
import Sunshine from './Sunshine';
// - T -
import TakeItEasy from './TakeItEasy';
import TearsInHeaven from './TearsInHeaven';
import TheCatCameBack from './TheCatCameBack';
import TheSoundOfSilence from './TheSoundOfSilence';
import ThisLandIsYourLand from './ThisLandIsYourLand';
import TieMeKangarooDownSport from './TieMeKangarooDownSport';
import TurnTurnTurn from './TurnTurnTurn';
// - W -
import WalkingOnSunshine from './WalkingOnSunshine';
import WhatTheWorldNeedsNowIsLove from './WhatTheWorldNeedsNowIsLove';
import WhereHaveAllTheFlowersGone from './WhereHaveAllTheFlowersGone';
import WithOrWithoutYou from './WithOrWithoutYou';
// - Y -
import YellowSubmarine from './YellowSubmarine';
import YouAreMySunshine from './YouAreMySunshine';
import YoureStillTheOne from './YoureStillTheOne';

export default {
	// - A -
	AHorseWithNoName,
	AmericanPie,
	// - B -
	BabyBaluga,
	BabyILoveYourWay,
	BackHome,
	BlowinInTheWind,
	ButterflyKisses,
	// - C -
	CantHelpFallingInLove,
	ClosingTime,
	CountryRoads,
	// - D -
	DontStopBelievin,
	// - F -
	ForeverAndEverAmen,
	FreeFallin,
	// - G -
	GivingTree,
	GodBlessTheUSA,
	GoodAsYou,
	// - H -
	HesGotTheWholeWorldInHisHands,
	HomeOnTheRange,
	HouseAtPoohCorner,
	// - I -
	ICantMakeYouLoveMe,
	IKnowAnOldLadyWhoSwallowedAFly,
	ItsYourLove,
	// - J -
	Jumper,
	// - K -
	KillingMeSoftly,
	Kookaburra,
	Kumbaya,
	// - L -
	LeanOnMe,
	LeavingOnAJetPlane,
	// - M -
	MaggieMay,
	MakeYouFeelMyLove,
	MichaelFinnegan,
	MichaelRowTheBoatAshore,
	Mockingbird,
	MyBonnieLiesOverTheOcean,
	// - N -
	NightChanges,
	// - O -
	OhSusanna,
	OnTopOfSpaghetti,
	OneTinSoldier,
	OverTheRainbow,
	// - P -
	PuffTheMagicDragon,
	// - R -
	RainbowConnection,
	RightHereWaiting,
	// - S -
	SesameStreetIDontWantToLiveOnTheMoon,
	ShellBeComingRoundTheMountain,
	SittinOnTheDockOfTheBay,
	StandByMe,
	Sunshine,
	// - T -
	TakeItEasy,
	TearsInHeaven,
	TheCatCameBack,
	TheSoundOfSilence,
	ThisLandIsYourLand,
	TieMeKangarooDownSport,
	TurnTurnTurn,
	// - W -
	WalkingOnSunshine,
	WhatTheWorldNeedsNowIsLove,
	WhereHaveAllTheFlowersGone,
	WithOrWithoutYou,
	// - Y -
	YellowSubmarine,
	YouAreMySunshine,
	YoureStillTheOne,
};
